import React, { useState } from 'react'
import { Input, Button, List, Card, Empty } from 'antd'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { formatCurrency } from '../../../../InventoryItems/utils/helpers'
import styles from './InventoryItemsTable.module.css'

const InventoryItemsTable = ({ inventory, addOrderItem }) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [searching, setSearching] = useState(false)

  // Handle search
  const handleSearch = (value) => {
    setSearchTerm(value)
    if (!value.trim()) {
      setSearchResults([])
      return
    }

    // Search through inventory items
    setSearching(true)
    const results = inventory
      .filter(
        (item) =>
          item.name.toLowerCase().includes(value.toLowerCase()) ||
          item.category.toLowerCase().includes(value.toLowerCase()) ||
          (item.itemCode && item.itemCode.toLowerCase().includes(value.toLowerCase()))
      )
      .slice(0, 10) // Limit to 10 results for performance

    setSearchResults(results)
    setSearching(false)
  }

  return (
    <div className={styles.searchContainer}>
      <Input.Search
        placeholder='Search by name, category or item code'
        allowClear
        size='large'
        value={searchTerm}
        onChange={(e) => handleSearch(e.target.value)}
        onSearch={handleSearch}
        loading={searching}
        enterButton={
          <Button type='primary'>
            <SearchOutlined className={styles.searchIcon} />
          </Button>
        }
      />

      {searchResults.length > 0 ? (
        <List
          grid={{ gutter: 16, column: 1 }}
          dataSource={searchResults}
          style={{ marginTop: 16 }}
          renderItem={(item) => (
            <List.Item>
              <Card size='small'>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontWeight: 'bold' }}>{item.name}</div>
                    <div>Category: {item.category}</div>
                    <div>
                      In Stock: {item.quantityOnHand} · Unit Cost: {formatCurrency(item.unitCost)}
                    </div>
                  </div>
                  <Button type='primary' icon={<PlusOutlined />} onClick={() => addOrderItem(item)}>
                    Add
                  </Button>
                </div>
              </Card>
            </List.Item>
          )}
        />
      ) : searchTerm ? (
        <Empty description='No items found' />
      ) : null}
    </div>
  )
}

export default InventoryItemsTable
